import { status } from 'skin/event/status'

function kindlist(obj, ms, story, data, d, action) {
    const row = story.current.table.tnk_kindList.row;
	if (obj.key === row) return status.ignore
	return status.action
}

export default kindlist
